import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'app-document-review',
  templateUrl: './document-review.component.html',
  styleUrls: ['./document-review.component.css']
})
export class DocumentReviewComponent implements OnInit {

public showAll!:boolean;

  constructor(@Inject(MAT_DIALOG_DATA) public data: any,  public dialogRef: MatDialogRef<DocumentReviewComponent>,) { }

  ngOnInit() {
   if(!this.data.inputType){
     this.showAll = false;
   }else{
    this.showAll = true;
   }
  }

  closeDialog(){
    this.dialogRef.close();
  }
}
